import { makeID } from '../services/utils';


class plugins {
  // we use this class to load global plugins
  constructor() {
    // tab selectors
    this.tabSelect = $('.tab-select');
    this.tabNav = $('.tab-nav');
    this.tabContent = $('.tab-content');

    // table selectors
    this.fixedColTable = $('.table[data-col-fixed]');

    // datepicker selector
    this.datepicker = $('.input-date');

    this.foundation();
    this.validator();
    this.svg4everybody();
    this.select();
    this.breadcrumbs();
    this.filters();
    this.tab();
    this.table();
    this.fdatepicker();
    this.cleave();
  }

  foundation() {
    $(document).foundation();
  }

  svg4everybody() {
    svg4everybody();
  }

  validator() {
    const forms = $('[data-validate]');
    if (!forms.length) return;
    var errorList = [];

    Parsley.addValidator('genericCustomValidation', {
      requirementType: 'string',
      validateString: function(value, requirement) {
        return requirement === 'valid';
      }
    });

    forms.each((i, form) => {
      $(form).parsley({
        errorClass: 'is-invalid-input',
        successClass: 'is-valid-input',
        errorsWrapper: '<div class="errors-list"></div>',
        errorTemplate: '<span class="form-error is-visible"></span>',
        errorsContainer: e => e.$element.closest('label')
      }).on('field:error', (e) => {
        e.$element
          .closest('label')
          .removeClass('is-valid-label')
          .addClass('is-invalid-label');
      }).on('field:success', (e) => {
        e.$element
          .closest('label')
          .removeClass('is-invalid-label')
          .addClass('is-valid-label');
      })
        .on('form:error', (e) => {
          $(e.$element).find('.is-invalid-input').each(function (e, v) {
            errorList.push(v);
          });

          $(window).trigger('submittedForm:error', { form: $(this), errorList: errorList.slice(0) });
          errorList.splice(0, errorList.length); // reset error list array

          $(window).trigger('submittedForm:error', { form: $(this), errorList: errorList.slice(0) });
        });
    });
  }

  breadcrumbs() {
    var breadcrumbs = $('.breadcrumbs-filters').find('.breadcrumbs-wrapper.scrollable-list');
    breadcrumbs.removeClass('align-items-right').removeClass('align-items-left');
    if (breadcrumbs.find('.breadcrumbs-nav').length > 0 && breadcrumbs.find('.breadcrumbs-nav')[0].scrollWidth > breadcrumbs.innerWidth()) {
      breadcrumbs.addClass('align-items-right');
      breadcrumbs.find('.breadcrumbs-nav.is-left-aligned').remove();
    } else {
      breadcrumbs.addClass('align-items-left');
      breadcrumbs.find('.breadcrumbs-nav.is-right-aligned').remove();
    }
    breadcrumbs.css('opacity', 1);
  }

  filters() {
    // Fix filters bar on scroll
    $(window).scroll(function (e) {
      var filters = $('.nav-filters-sorting-wrapper');
      if ($(this).scrollTop() > 529) {
        filters.addClass('is-fixed');
      } else {
        filters.removeClass('is-fixed');
      }
    });
  }

  select() {
    // Handle select picker with redirect urls
    $('.select-picker-redirect').on('change', function () {
      var redirectUrl = this.value;
      var eventLabel = this.options[this.selectedIndex].getAttribute('data-event-label');
      $(this).prop('selectedIndex', 0);

      dataLayer.push({
        'event': 'asyncAction',
        'gaHitType' : 'event',
        'event_category' : 'breadcrumbs',
        'event_action' : 'third_level',
        'event_label' : eventLabel
       });

      window.location.href = redirectUrl;
    });

    // Handle select picker with sub-categories
    $('.select-picker-redirect-category').on('change', function () {
      var selectedValue = this.value;
      var eventLabel = this.options[this.options.selectedIndex].getAttribute('data-event-label');

      $(this).prop('selectedIndex', 0);

      var dataLayerObject = {
        event: 'asyncAction',
        gaHitType: 'event',
        event_category: 'fascia_categorie',
        event_action: (($(this).data('level') == '3') ? 'third_level' : 'second_level'),
        event_label: eventLabel
      };

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push(dataLayerObject);
      }

      setTimeout(function () {
        window.location.href = selectedValue;
      }, 100);
    });

    // Handle select picker with sortings
    $('.select-picker-redirect-sorting').on('change', function () {
      var selectedValue = this.value;
      $(this).prop('selectedIndex', 0);

      var dataLayerObject = {
        event: 'asyncAction',
        gaHitType: 'event',
        event_category: 'filters',
        event_action: 'sort_by',
        event_label: selectedValue
      };

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push(dataLayerObject);
      }

      setTimeout(function () {
        var target = $('[data-id="' + selectedValue + '"] a');
        var href = $(target).attr('href');

        window.location.href = href;
      }, 100);
    });

    if (['small', 'medium'].indexOf(Foundation.MediaQuery.current) > -1) return;

    const makeCustom = (select) => {
      if (!$(select).attr('data-id')) $(select).attr('data-id', makeID());
      $(select).customSelect({
        transition: 300,
        modifier: `${$(select).attr('class')} ${$(select).attr('data-id')}`
      });

      $(select).on('change', function () {
        $(this).trigger('refresh');
      });
    };

    let debounce = {};
    $('select:not(.nocustom):not(.hidden)').each((i, select) => {
      makeCustom(select);

      $(select).on('DOMSubtreeModified, refresh', (e) => {
        const id = $(e.currentTarget).data('id');
        if (debounce[id]) {
          clearTimeout(debounce[id]);
          debounce[id] = null;
        }

        debounce[id] = setTimeout(() => {
          $(e.currentTarget).removeData('custom-select');
          $(`.${id}`).remove();
          makeCustom(e.currentTarget);
        }, 100);
      });
    });
  }

  tab() {
    // show-hide tab content
    const updateView = (targetContent) => {
      this.tabContent.removeClass('is-active');
      $(`#${targetContent}`).addClass('is-active');

      $(window).trigger('resize');
    };

    // update view based on target clicked - desktop
    this.tabNav.on('click', 'a', (e) => {
      e.preventDefault();
      const targetContent = $(e.currentTarget).parents('li').data('target');
      this.tabNav.find('li').removeClass('is-current');
      $(e.currentTarget).parents('li').addClass('is-current');
      // update mobile select value
      this.tabSelect.val(targetContent);
      if (['small', 'medium'].indexOf(Foundation.MediaQuery.current) === -1) {
        this.tabSelect.removeData('custom-select').show().next('.custom-select').remove();
        this.tabSelect.customSelect({
          transition: 300,
          modifier: this.tabSelect.attr('class')
        });
      }
      updateView(targetContent);

      $(document).trigger('tabToggle', targetContent);
    });

    // update view based on target chosen - mobile
    this.tabSelect.on('change', (e) => {
      e.preventDefault();
      const targetContent = $(e.currentTarget).val();
      // update desktop cta list
      this.tabNav.find('li').removeClass('is-current');
      this.tabNav.find(`li[data-target="${targetContent}"]`).addClass('is-current');
      updateView(targetContent);
    });
  }

  table() {
    const defaultThWidth = 90;
    const getThrWidth = (table) => {
      let tableWidth = table.width();
      let tdrWidth = table.find('.tdr').width();
      return tableWidth - tdrWidth;
    };

    const handleCols = (table) => {
      const thrWidth = table.find('.thr').width();
      const tdrWidth = table.find('.tdr').width();
      const tableOverflowWidth = table.parents('.table-overflow').width();

      if (thrWidth + tdrWidth < tableOverflowWidth) {
        table.find('.th').css('width', 'auto');
        table.parents('.table-container').find('.thr-fixed').hide();
        table.css('width', 'auto');
      } else {
        table.find('.th').width(defaultThWidth);
        table.parents('.table-container').find('.thr-fixed').show();
        table.css({
          width: defaultThWidth + tdrWidth,
          'min-width': defaultThWidth + tdrWidth
        });
      }
    };

    this.fixedColTable.each(function () {
      let tableWidth = $(this).width();
      let thrWidth = Math.max.apply(Math, $(this).find('.thr').map(function () {
        return $(this).width();
      }).get());
      let tdrWidth = $(this).find('.tdr:last-of-type').width();

      $(this).css('min-width', thrWidth + tdrWidth);
      $(this).parents('.table-container').prepend('<div class="thr-fixed"></div>');
      $(this).find('.tr').each((i, tr) => {
        let thString = $(tr).find('.th').text();
        $(this).parents('.table-container').find('.thr-fixed').append('<div class="tr"><ul class="thr"><li class="th">' + thString + '</li></ul></div>');
      });
      handleCols($(this));
    });

    $(window).on('resize', () => {
      this.fixedColTable.each(function () {
        handleCols($(this));
      });
    });
  }

  fdatepicker() {
    this.datepicker.fdatepicker({
      language: $('html').attr('lang'),
      leftArrow: `<svg><use xlink:href="${window.staticURL}/images/sprite.svg#arrow-left" /></use></svg>`,
      rightArrow: `<svg><use xlink:href="${window.staticURL}/images/sprite.svg#arrow-right" /></use></svg>`,
      format: 'mm/dd/yyyy',
      endDate: new Date()
    });
  }


  cleave() {
    $('.input-date-cleave').each((i, el) => {
      if (Cleave) {
        let format = $(el).data('format').toUpperCase()
          .replace('MM', 'm')
          .replace('DD', 'd')
          .replace('YYYY', 'Y');
        let split = format.split('/');

        let minDate = $(el).data('min');
        let maxDate = $(el).data('max');

        const option = {
          date: true,
          delimiter: '/',
          datePattern: split
        }

        if(!!minDate) option.dateMin = minDate;
        if(!!maxDate) option.dateMax = maxDate;

        let cl = new Cleave(el, option);
      } else {
        console.error('found a date field but Cleave is not imported');
      }
    });

    $('.input-phone').each((i, el) => {
      if (Cleave) {
        let cl = new Cleave(el, {
          phone: true
        });
      } else {
        console.error('found a phone field but Cleave is not imported');
      }
    });
  }
}

const Plugins = new plugins();
export default Plugins;



// WEBPACK FOOTER //
// ./assets/scripts/components/plugins.js